import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatchFilterId, MatchFilterOption } from '../sportsbook/sportsbook.models';
import { MatchSearchComponent } from '../match-search/match-search.component';

@Component({
  selector: 'app-match-filter',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatchSearchComponent],
  templateUrl: './match-filter.component.html',
  styleUrl: './match-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchFilterComponent {
  readonly filters = input.required<readonly MatchFilterOption[]>();
  readonly activeFilter = input.required<MatchFilterId>();
  readonly searchExpanded = input.required<boolean>();
  readonly searchVisible = input(true);
  readonly searchQuery = input.required<string>();

  readonly filterChange = output<MatchFilterId>();
  readonly searchToggle = output<void>();
  readonly searchChange = output<string>();

  protected readonly trackFilter = (_: number, filter: MatchFilterOption): MatchFilterId => filter.id;
}
